import FalconCloseButton from 'components/common/FalconCloseButton';
import Flex from 'components/common/Flex';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { AiOutlineRight } from 'react-icons/ai';
import PropTypes from 'prop-types';

const ModalSelectExportType = props => {
  const { showModal, handleCloseModal, onClick } = props;
  const exportType = [
    {
      title: 'PDF'
    },
    {
      title: 'CSV'
    }
  ];
  return (
    <Modal
      size="lg"
      show={showModal}
      onHide={handleCloseModal}
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Select Export Type</Modal.Title>
        <FalconCloseButton onClick={handleCloseModal} />
      </Modal.Header>
      <Modal.Body>
        <>
          {exportType.map((type, index) => {
            return (
              <Flex
                key={index}
                onClick={() => onClick(type.title)}
                alignItems="center"
                justifyContent="between"
                className={
                  'rounded-3 bg-light p-3 order-product-filter-list mb-2'
                }
              >
                <>
                  <Flex direction={'column'}>
                    <h6 className="mb-0">{type.title}</h6>
                  </Flex>
                  <span className="fs--2 text-600 mb-0">
                    <AiOutlineRight />
                  </span>
                </>
              </Flex>
            );
          })}
        </>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
ModalSelectExportType.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ModalSelectExportType;
